import { Entry } from '../Entry'

export function Entry20260318() {
  return (
    <Entry title="2026 Mar 18 - v3.11.9">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/21653/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
